<template>
  <div class="app-content">
    <Content class="app-content__main">
      <order-chart />
    </Content>
  </div>
</template>
<script>
import OrderChart from "@/components/dashboard/OrderChart.vue";

export default {
  components: {OrderChart}

}
</script>
